import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=6f32f1bb"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f32f1bb')) {
      api.createRecord('6f32f1bb', component.options)
    } else {
      api.reload('6f32f1bb', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=6f32f1bb", function () {
      api.rerender('6f32f1bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Notes.vue"
export default component.exports